// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610202206/js/" + chunkId + "." + {"44":"3a42d376","225":"50db7bff","481":"6b8b55cf","486":"8da63304","770":"f0c7cb44"}[chunkId] + ".0.8663838786669742.chunk.js";
};